export const ADDING_SECURITY_GROUP = 'ADDING_SECURITY_GROUP';
export const ADD_SECURITY_GROUP_SUCCESS = 'ADD_SECURITY_GROUP_SUCCESS';
export const ADD_SECURITY_GROUP_FAIL = 'ADD_SECURITY_GROUP_FAIL';
export const PATCHING_SECURITY_GROUP = 'PATCHING_SECURITY_GROUP';
export const PATCH_SECURITY_GROUP_SUCCESS = 'PATCH_SECURITY_GROUP_SUCCESS';
export const PATCH_SECURITY_GROUP_FAILED = 'PATCH_SECURITY_GROUP_FAILED';
export const UPDATE_PERMISSION = 'UPDATE_SECURITY_GROUP_PERMISSION';
export const ADD_PERMISSION_TO_GROUP = 'ADD_PERMISSION_TO_GROUP';
export const REMOVE_PERMISSION_FROM_GROUP = 'REMOVE_PERMISSION_FROM_GROUP';
export const ADD_USERS_TO_GROUP = 'ADD_USERS_TO_GROUP';
export const REMOVE_USER_FROM_GROUP = 'REMOVE_USER_FROM_GROUP';
export const FETCHING_PERMISSIONS = 'FETCHING_PERMISSIONS';
export const FETCH_PERMISSIONS_SUCCESS = 'FETCH_PERMISSIONS_SUCCESS';
export const FETCH_PERMISSIONS_FAIL = 'FETCH_PERMISSIONS_FAIL';
export const FETCHING_FEATURES = 'FETCHING_FEATURES';
export const FETCH_FEATURES_SUCCESS = 'FETCH_FEATURES_SUCCESS';
export const FETCH_FEATURES_FAIL = 'FETCH_FEATURES_FAIL';
export const FETCHING_APPS = 'FETCHING_APPS';
export const FETCH_APPS_SUCCESS = 'FETCH_APPS_SUCCESS';
export const FETCH_APPS_FAIL = 'FETCH_APPS_FAIL';
export const TOGGLE_SECURITY_MODAL = 'TOGGLE_SECURITY_MODAL';
export const RESET_OPERATION_STATUS = 'RESET_OPERATION_STATUS';
export const DELETING_SECURITY_GROUP = 'DELETING_SECURITY_GROUP';
export const SECURITY_GROUP_DELETE_SUCCESS = 'SECURITY_GROUP_DELETE_SUCCESS';
export const SECURITY_GROUP_DELETE_FAIL = 'SECURITY_GROUP_DELETE_FAIL';
export const FETCHING_SECURITY_GROUPS = 'FETCHING_SECURITY_GROUPS';
export const FETCH_SECURITY_GROUPS_SUCCESS = 'FETCH_SECURITY_GROUPS_SUCCESS';
export const FETCH_SECURITY_GROUPS_FAILED = 'FETCH_SECURITY_GROUPS_FAILED';
export const FETCHING_SECURITY_GROUP = 'FETCHING_SECURITY_GROUP';
export const FETCH_SECURITY_GROUP_SUCCESS = 'FETCH_SECURITY_GROUP_SUCCESS';
export const FETCH_SECURITY_GROUP_FAILED = 'FETCH_SECURITY_GROUP_FAILED';
export const UPDATE_SECURITY_GROUP = 'UPDATE_SECURITY_GROUP';
export const UPDATING_USERS = 'UPDATING_USERS';
export const UPDATE_USERS_SUCCESS = 'UPDATE_USERS_SUCCESS';
export const UPDATE_USERS_FAILED = 'UPDATE_USERS_FAILED';
export const UPDATING_PERMISSIONS = 'UPDATING_PERMISSIONS';
export const UPDATE_PERMISSIONS_SUCCESS = 'UPDATE_PERMISSIONS_SUCCESS';
export const UPDATE_PERMISSIONS_FAILED = 'UPDATE_PERMISSIONS_FAILED';
export const UPDATING_APPS = 'UPDATING_APPS';
export const UPDATE_APPS_SUCCESS = 'UPDATE_APPS_SUCCESS';
export const UPDATE_APPS_FAILED = 'UPDATE_APPS_FAILED';
export const UPDATE_APPS = 'UPDATE_APPS';
export const FORM_CHANGE = '@@redux-form/CHANGE';
export const ADD_APP = 'ADD_APP';
export const REMOVE_APP = 'REMOVE_APP';

export function updatePermission(permission) {
    return {
        type: UPDATE_PERMISSION,
        payload: permission
    };
}

export function fetchingPermissions() {
    return {
        type: FETCHING_PERMISSIONS
    };
}

export function fetchPermissionsSuccess(permissions) {
    return {
        type: FETCH_PERMISSIONS_SUCCESS,
        payload: permissions
    }
}

export function fetchPermissionsFail(err) {
    return {
        type: FETCH_PERMISSIONS_FAIL,
        payload: err
    };
}

export function fetchingFeatures() {
    return {
        type: FETCHING_FEATURES
    };
}

export function fetchFeaturesSuccess(features) {
    return {
        type: FETCH_FEATURES_SUCCESS,
        payload: features
    }
}

export function fetchFeaturesFail(err) {
    return {
        type: FETCH_FEATURES_FAIL,
        payload: err
    };
}

export function updateSecurityGroup(securityGroup) {
    return {
        type: UPDATE_SECURITY_GROUP,
        payload: securityGroup
    };
}

export function patchingSecurityGroup() {
    return {
        type: PATCHING_SECURITY_GROUP
    }
}

export function patchSecurityGroupSuccess(securityGroup) {
    return {
        type: PATCH_SECURITY_GROUP_SUCCESS,
        payload: securityGroup
    };
}

export function patchSecurityGroupFailed(err) {
    return {
        type: PATCH_SECURITY_GROUP_FAILED,
        payload: err
    }
}

export function addSecurityGroupSuccess(securityGroup) {
    return {
        type: ADD_SECURITY_GROUP_SUCCESS,
        payload: securityGroup
    };
}

export function addSecurityGroupFail(err) {
    return {
        type: ADD_SECURITY_GROUP_FAIL,
        payload: err
    };
}

export function addingSecurityGroup() {
    return {
        type: ADDING_SECURITY_GROUP
    }
}

export function fetchingApps() {
    return {
        type: FETCHING_APPS
    };
}

export function fetchAppsSuccess(apps) {
    return {
        type: FETCH_APPS_SUCCESS,
        payload: apps
    };
}

export function fetchAppsFailed(err) {
    return {
        type: FETCH_APPS_FAIL,
        payload: err
    };
}

export function toggleSecurityModal() {
    return {
        type: TOGGLE_SECURITY_MODAL
    };
}

export function resetOperationStatus() {
    return {
        type: RESET_OPERATION_STATUS
    };
}

export function deletingSecurityGroup() {
    return {
        type: DELETING_SECURITY_GROUP
    }
}

export function securityGroupDeleteSuccess(securityGroupId) {
    return {
        type: SECURITY_GROUP_DELETE_SUCCESS,
        payload: securityGroupId
    }
}

export function securityGroupDeleteFail(err) {
    return {
        type: SECURITY_GROUP_DELETE_FAIL,
        payload: err
    };
}

export const fetchingSecurityGroups = () => {
    return {
        type: FETCHING_SECURITY_GROUPS
    };
};

export const fetchSecurityGroupsSuccess = securityGroups => {
    return {
        type: FETCH_SECURITY_GROUPS_SUCCESS,
        payload: securityGroups
    };
};

export const fetchSecurityGroupsFailed = err => {
    return {
        type: FETCH_SECURITY_GROUPS_FAILED,
        payload: err
    };
};

export const fetchingSecurityGroup = id => {
    return {
        type: FETCHING_SECURITY_GROUP,
        payload: id
    }
};

export const fetchSecurityGroupSuccess = securityGroup => {
    return {
        type: FETCH_SECURITY_GROUP_SUCCESS,
        payload: securityGroup
    };
};

export const fetchSecurityGroupFailed = err => {
    return {
        type: FETCH_SECURITY_GROUP_FAILED,
        payload: err
    };
};

export const updatingUsers = () => {
    return {
        type: UPDATING_USERS
    }
};

export const updateUsersSuccess = (users) => {
    return {
        type: UPDATE_USERS_SUCCESS,
        payload: users
    }
};

export const updateUsersFailed = (err) => {
    return {
        type: UPDATE_USERS_FAILED,
        payload: err
    };
};

export const updatingPermissions = () => {
    return {
        type: UPDATING_PERMISSIONS
    }
};

export const updatePermissionsSuccess = (permissions) => {
    return {
        type: UPDATE_PERMISSIONS_SUCCESS,
        payload: permissions
    };
};

export const updatePermissionsFailed = (err) => {
    return {
        type: UPDATE_PERMISSIONS_FAILED,
        payload: err
    }
};

export function updatingApps() {
    return {
        type: UPDATING_APPS
    };
}

export function updateAppsSuccess(version) {
    return {
        type: UPDATE_APPS_SUCCESS,
        payload: version
    };
}

export function updateAppsFailed(err) {
    return {
        type: UPDATE_APPS_FAILED,
        payload: err
    };
}

export function updateApps(appIds) {
    return {
        type: UPDATE_APPS,
        payload: appIds
    };
}

export function addApp(appId) {
    return {
        type: ADD_APP,
        payload: appId
    }
}

export function removeApp(appId) {
    return {
        type: REMOVE_APP,
        payload: appId
    }
}
